
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface CommentDialogProps {
    open: boolean;
    comment: string;
    isCommentRequired: boolean;
    canSubmit: boolean;
    onCancel: () => void;
    onSubmit: () => void;
    onCommentChange: (value: string) => void;
}

export const CommentDialog: React.FC<CommentDialogProps> = ({
    open,
    comment,
    isCommentRequired,
    canSubmit,
    onCancel,
    onSubmit,
    onCommentChange,
}) => (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>Confirm Status Change</AlertDialogTitle>
                <AlertDialogDescription>
                    Please provide a comment to continue. The comment is
                    optional for Verified status but required for Needs Review
                    status.
                </AlertDialogDescription>
            </AlertDialogHeader>
            <div className="grid w-full gap-1.5">
                <Label htmlFor="comment">
                    Comment{' '}
                    {isCommentRequired && (
                        <span className="text-destructive">*</span>
                    )}
                </Label>
                <Textarea
                    id="comment"
                    placeholder="Type your comment here..."
                    value={comment}
                    onChange={(e) => onCommentChange(e.target.value)}
                />
            </div>
            <AlertDialogFooter>
                <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
                <AlertDialogAction onClick={onSubmit} disabled={!canSubmit}>
                    Confirm
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
);
